export default { getMetaContent, checkValidity, applePaymentRequest, initializeApplePay, googlePaymentRequest, initializeGoogle, initializeCard,  createPayment, tokenize, handlePaymentMethodSubmission }

function getMetaContent(prop) {
  let res = document.querySelector(`meta[name="${prop}"]`)

  if (res) {
    return res.getAttribute('content');
  } else {
    return ""
  }
}

async function applePaymentRequest(payments) {
  let amount = document.getElementById("pay-amount").value;

  const paymentRequest = payments.paymentRequest({
      countryCode: 'AU',
      currencyCode: 'AUD',
      total: {
        amount: amount,
        label: 'Total',
      },
    });

  const applePay = await payments.applePay(paymentRequest);

  return applePay
}

async function initializeApplePay(payments, el) {
  const applePay = await applePaymentRequest(payments);
  await applePay.attach('#' + el.id);

  return applePay;
}

async function googlePaymentRequest(payments) {
  let amount = document.getElementById("pay-amount").value;

  const paymentRequest = payments.paymentRequest({
      countryCode: 'AU',
      currencyCode: 'AUD',
      total: {
        amount: amount,
        label: 'Total',
      },
    });

  const googlePay = await payments.googlePay(paymentRequest);

  return googlePay
}

async function initializeGoogle(payments, el) {
  const googlePay = await googlePaymentRequest(payments);
  await googlePay.attach('#' + el.id);

  return googlePay;
}

async function initializeCard(payments, el) {
  const card = await payments.card();
  await card.attach('#' + el.id);

  return card;
}

// Add details about amount/form/page
// Make JSON call to backend
async function createPayment(form, amount, token, verificationToken) {
  let locationId = getMetaContent("square_location");

  const body = JSON.stringify({
    payment: {
      form_id: form.id,
      form_title: form.title,
      reference_id: form.id,
      note: form.title,
      title: `Sophie's Legacy Incorporated - ${form.title}`,
      statement_description_identifier: form.title,
      amount: amount,
      location_id: locationId,
      source_id: token,
      verification_token: verificationToken,
      idempotency_key: window.crypto.randomUUID(),
    },
    contact: buildContact(),
    subscription: {
      subscription_plan_id: getRoleValue("subscription-plan-id")
    }
  });

  const paymentResponse = await fetch('/api/payments/square', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body
  });

  let statusMsg = document.getElementById("payment-status-message")
  if (paymentResponse.ok) {

    if (statusMsg) {
      statusMsg.innerHTML = ``;
    }

    return paymentResponse.json();
  } else {
      const errorBody = await paymentResponse.json();

      if (statusMsg) {
        statusMsg.innerText = `An error occurred: ${errorBody.message}`;
      }
  }

}

async function tokenize(paymentMethod) {
  const tokenResult = await paymentMethod.tokenize();

  if (tokenResult.status === 'OK') {
    return tokenResult.token;
  } else {
    let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
    if (tokenResult.errors) {
      errorMessage += ` and errors: ${JSON.stringify(
        tokenResult.errors,
      )}`;
    }

    throw new Error(errorMessage);
  }
}

function getRoleValue(roleName) {
  let selector = document.querySelector(`[data-role=${roleName}]`);

  if (selector != undefined ) {
    let val = selector.value;

    if (val == '' || typeof val === 'undefined' || val == null) {
      return null;
    } else {
      return val;
    }
  }
}

function buildContact() {
    return {
        idempotency_key: window.crypto.randomUUID(),
        given_name: getRoleValue("givenName"),
        family_name: getRoleValue("familyName"),
        email_address: getRoleValue("email"),
        phone_number: getRoleValue("phone"),
        address: { 
              address_line_1: getRoleValue("address"),
              country: getRoleValue("country"),
              locality: getRoleValue("city"),
              postal_code: getRoleValue("post_code")
        }
      };
}

// Required in SCA Mandated Regions: Learn more at https://developer.squareup.com/docs/sca-overview
async function verifyBuyer(payments, token, amount) {
  if (amount) {
    let contact = buildContact()

    let billingContact = {}

    if (contact.given_name) { billingContact.givenName = contact.given_name };
    if (contact.family_name) { billingContact.familyName = contact.family_name };
    if (contact.email_address) { billingContact.email = contact.email_address };
    if (contact.phone_number) { billingContact.phone = contact.phone_number };
    if (contact.address.city) { billingContact.city = contact.address.city };
    if (contact.address.country) { billingContact.countryCode = contact.address.country };
    if (contact.address.address_line_1) { billingContact.addressLines = [ contact.address_line_1 ] };

    const verificationDetails = {
      amount: amount,
      billingContact: billingContact,
      currencyCode: 'AUD',
      intent: 'CHARGE',
    };

    const verificationResults = await payments.verifyBuyer(
      token,
      verificationDetails,
    );

    return verificationResults.token;
  } else {
    throw new Error("No amount found");
  }
}

    // {
    //   givenName: 'John',
    //   familyName: 'Doe',
    //   email: 'john.doe@square.example',
    //   phone: '3214563987',
    //   addressLines: ['123 Main Street', 'Apartment 1'],
    //   city: 'London',
    //   state: 'LND',
    //   countryCode: 'GB',
    // },
//
function isRoleValid(roleName) {
  let selector = document.querySelector(`[data-role=${roleName}]`);

  if (selector != undefined ) {
      return selector.validity.valid
  } else {
    return false
  }
}

function isValid() {
  return isRoleValid("givenName") && isRoleValid("familyName") && isRoleValid("email")
}

function checkValidity() {
  let statusMsg = document.getElementById("payment-status-message")
  let holder = document.getElementById("payment-details-holder")
  let payNowButton = document.getElementById("payment-button")
  let validityMsg =  "Given name, family name and email are required."

  if (isValid()) {
    if (statusMsg.innerText == validityMsg) {
      statusMsg.classList.add("hidden")
      statusMsg.classList.remove("text-pink-700")
      statusMsg.innerText = ""
      // holder.classList.remove("hidden")
    }
    payNowButton.disabled = false
    payNowButton.title = "Pay Now"
  } else {
    statusMsg.classList.remove("hidden")
    // holder.classList.add("hidden")
    statusMsg.classList.add("text-pink-700")
    statusMsg.innerText = validityMsg
    payNowButton.disabled = true
    payNowButton.title = validityMsg
  }
}

async function handlePaymentMethodSubmission(form, event, payments, card, cardButton) {
  event.preventDefault();

  let statusMsg = document.getElementById("payment-status-message")

  if (isValid()) {
    try {
      // disable the submit button as we await tokenization and make a payment request.
      //
      let amount = document.getElementById("pay-amount").value;

      const statusContainer = document.getElementById('payment-status-container');
      let loading = statusContainer.querySelector("#payment-status-loading")

      loading.classList.remove("stroke-slate-300")
      loading.classList.add("stroke-blue-300", "animate-spin")
      statusMsg.classList.remove("hidden")
      statusMsg.classList.remove("text-pink-700")

      if (cardButton) {
        cardButton.disabled = true;
      }

      let holder = document.getElementById("payment-details-holder")
      if (holder) {
        holder.classList.add("hidden")
      }

      let types = document.getElementById("payment-types-holder")
      if (types) {
        types.classList.add("hidden")
      }

      const token = await tokenize(card);

      statusMsg.innerText = "Verifying buyer information"

      const verificationToken = await verifyBuyer(payments, token, amount);

      statusMsg.innerText = "Verified buyer. Creating payment"

      const paymentResults = await createPayment(
        form,
        amount,
        token,
        verificationToken
      );

      displayPaymentResults('SUCCESS');

      document.getElementById("answer-form-field").value = paymentResults.amount
      document.getElementById("payment-form-field").value = paymentResults.id

      statusMsg.innerHTML = `Thank you. We have sent an email with your receipt.`

      let completeForm = document.getElementById(`form-inline-completion-${form.id}`);

      if (completeForm) {
        completeForm.disabled = false;
        requestAnimationFrame(() => {
          completeForm.click();
        });
      }

    } catch (e) {
      if (cardButton) {
        cardButton.disabled = false;
      }
      displayPaymentResults('FAILURE');
    }
  } else {
    statusMsg.classList.remove("hidden")
    statusMsg.classList.add("text-pink-700")
    statusMsg.innerText = "Given name, family name and email are required"
  }
}

// status is either SUCCESS or FAILURE;
function displayPaymentResults(status) {
  const statusContainer = document.getElementById('payment-status-container');

  let ok = statusContainer.querySelector("#payment-status-ok")
  let bad = statusContainer.querySelector("#payment-status-bad")
  let loading = statusContainer.querySelector("#payment-status-loading")
  let buts = document.getElementById("cash-money-buttons")
  let outer = document.getElementById("payment-outer")

  if (status === 'SUCCESS') {
    ok.classList.remove('stroke-slate-300', 'border-slate-300');
    ok.classList.add('stroke-green-400', 'border-green-400');
    bad.classList.remove('stroke-red-400', 'border-red-400');
    bad.classList.add('stroke-slate-300', 'border-slate-300');

    if (buts) {
      buts.classList.add("hidden")
    }

    if (outer) {
      outer.classList.remove("bg-indigo-50")
      outer.classList.add("bg-yellow-400")
    }
  } else {
    bad.classList.remove('stroke-slate-300', 'border-slate-300');
    bad.classList.add('stroke-red-400', 'border-red-400');
    ok.classList.remove('stroke-green-400', 'border-green-400');
    ok.classList.add('stroke-slate-300', 'border-slate-300');

    let holder = document.getElementById("payment-details-holder")

    if (holder) {
      holder.classList.remove("hidden")
    }
    let types = document.getElementById("payment-types-holder")

    if (types) {
      types.classList.remove("hidden")
    }

    if (buts) {
      buts.classList.remove("hidden")
    }
  }

  loading.classList.add('stroke-slate-300');
  loading.classList.remove('stroke-blue-300', 'animate-spin');


  statusContainer.style.visibility = 'visible';
}

